export default {
  // Header
  'Search articles': 'Search articles',

  // Welcome
  'Everything about your pregnancy': 'Everything about your pregnancy',
  'Who are we': 'Who are we',
  'About': `Welcome to pregnerenportaal.nl! This is the place for
    all reliable information about your pregnancy. Find here the collection
    of everything you need during and after the arrival of your child`,

  'What do we offer': 'What do we offer',

  'Information from professionals': 'Information from professionals',
  'Find all articles': `Find all articles about you and your baby,
    written by professionals`,

  'Appointments with your midwife': 'Appointments with your midwife',
  'Manage and view your appointments': `Manage and view your appointments
    with your obstetric practice`,

  'The best offers': 'The best offers',
  'The best offers and benefits': `The best offers and benefits
    for mother, baby and family`,

  'View and manage your files': 'View and manage your files',
  'View and manage your midwife\'s records': `View and manage your
    midwife's records`,

  'Blogs and vlogs': 'Blogs and vlogs',
  'Various blogs and vlogs': `Various blogs and vlogs from other pregnant
    women about their experiences`,

  'Login': 'Login',
  'Log in': 'Log in',
  'Create an account': 'Create an account',
  'Forgot your password': 'Forgot your password',

  // User menu
  'Log out': 'Log out',
  'Profile': 'Profile',

  // Login form
  'Username or email': 'Username or email',
  'Password': 'Password',
  'The username or password you have entered is invalid':
    'The username or password you have entered is invalid',
  'Connection error': 'Connection error',

  // Register form
  'Full name': 'Full name',
  'Email': 'Email',
  'Phone': 'Phone',
  'Repeat password': 'Repeat password',
  'TermsHead': 'I agree with the',
  'TermsLink': 'general terms and conditions',
  'TermsTail': 'of zwangerenportaal.nl',
  'Your data is safe with us': 'Your data is safe with us',
  'PrivacyText': `We take your privacy seriously and always comply
    the legal provisions for this. We also take measures to protect
    your data. Do you want to know how we handle your privacy? Read our`,
  'PrivacyLink': 'privacy statement',
  'Do you already have an account': 'Do you already have an account',
  'Lost username': 'Lost username',
  'Request': 'Request',
  'Reset password': 'Reset password',
  'Need help to log in': 'Need help to log in',
  'Click for help': 'Click for help',

  // Articles
  'Read more': 'Read more',
  'Recent articles': 'Recent articles',
  'Load more recent articles': 'Load more recent articles',
  'Popular articles': 'Popular articles',
  'Load more popular articles': 'Load more popular articles',
  'Related articles': 'Related articles',
  'Load more related articles': 'Load more related articles',
  'Saved articles': 'Saved articles',
  'Load more saved articles': 'Load more saved articles',
  'New from channels': 'New from channels that you follow',
  'Load more articles': 'Load more articles',

  // Article
  'Previous': 'Previous',
  'Next': 'Next',

  // Advertisement
  'Advertisement': 'Advertisement',

  // Article author
  'Author of this article': 'Author of this article',
  'Subscribe': 'Subscribe',

  // Article reaction
  'Reactions': 'Reaction',
  'Header text': 'Let us know what do you think about this article',
  'Type something': 'Type something',

  // User
  'You are at': 'You are at',
  'Calculated date': 'Calculated date',
  'My healthcare provider': 'My healthcare provider',

  // Channels
  'Channels you follow': 'Channels you follow',
  'Subscribed': 'Subscribed',
  'View all channels': 'View all channels',

  // Appointment
  'Appointments': 'Appointments',
  'Description': 'Description',
  'Previous appointments': 'Previous appointments',

  // Files
  'My files': 'My files',
  'Provider': 'Provider',
  'Registered': 'Registered',
  'Integrated birth file': 'Integrated birth file',

  // File management
  'Files to be linked': 'Files to be linked',
  'Linked files': 'Linked files',
  'See': 'See',
  'Allow linking': 'Allow linking',

  // File linking
  'Unlinking': 'Unlinking',
  'Withdrawing permission': [`You have given us permission to make a link
    with the file from your obstetrician or other practitioner to increase your
    gestational age usage. You have the right to withdraw this permission at any
    time`, `By withdrawing the permission, you cannot no longer view the
    content of your file. It also means the content of the pregnancy portal will
    be changed. We use this data to provide you relevant information and give
    tips and email them around your pregnancy`],
  'File unlinking': `You are about to unlink the file below.
    Press "Agree" to unlink`,
  'Back to your files': 'Back to your files',

  // Profile settings
  'Settings': 'Settings',
  'Change': 'Change',
  'Change your password': 'Change your password',
  'Phone number': 'Phone number',
  'Profile visibility': 'Profile visibility',
  'Protected for everyone': 'Protected for everyone',
  'Postal code': 'Postal code',
  'Healthcare provider': 'Healthcare provider',
  'Weekmail': 'Weekmail',
  'Status': 'Status',
  'Back to profile': 'Back to profile',
  'Change profile photo': 'Change profile photo',
  'ChangeAttributeText': `Enter your username, e-mail address or mobile
    telephone number. We will send you the password reset information`,
  'ChangeAttributePlaceholder': 'Username, e-mail, phone number',
  'Drag a file here to upload': 'Drag a file here to upload',
  'Delete account': 'Delete account',
  'Delete': 'Delete',

  // Footer
  'Mission': `Zwangerenportaal.nl's mission is to inform couples optimally
    about their own pregnancies.`,
  'Languages': 'Languages',
  'English': 'English',
  'Dutch': 'Dutch',
  'Stay informed': 'Stay informed',
  'Rights': 'All rights reserved, zwangerenportaal.nl',
  'Frequently Asked Questions': 'Frequently Asked Questions',
  'Terms and Conditions': 'Terms and Conditions',
  'Privacy': 'Privacy',
  'Cookie statement': 'Cookie statement'
};
